export const ROLE_DATA = 'ROLE_DATA'
